import React from 'react';
import styles from './styleConstants.module.css';

// Wrapper to simulate vertical margins via internal padding to avoid margin collapse
export type SectionWrapperProps = {
  as?: any;
  $hasVerticalMargin?: boolean;
  className?: string;
} & React.HTMLAttributes<HTMLElement> &
  Record<string, any>;

export const SectionWrapper = React.forwardRef<any, SectionWrapperProps>(
  function SectionWrapper({ as, $hasVerticalMargin, className, ...rest }, ref) {
    const Tag: any = as || 'div';
    return (
      <Tag
        ref={ref}
        className={[styles.sectionWrapper, className]
          .filter(Boolean)
          .join(' ')}
        data-has-vertical-margin={$hasVerticalMargin ? 'true' : undefined}
        {...rest}
      />
    );
  },
);
